import styled from 'styled-components'

export const StyledFormWrapper = styled.div`
 .header {
  font-size: 16px !important;
  font-style: italic;
  font-weight: bold;
 }
 .form-divider {
  background: ${props => props.theme.firstColor};
  margin-top: -2px !important;   
  border-top: 2px solid rgba(34,36,38,.15) !important;
 } 
`
export const GeneralInfoWrapper = styled.div`
 min-width: 75%;
 max-width: 100%;
 .field {
  padding-left: 0px !important;
 }
 .loaderWrapper {
  position: relative;
    margin: auto;
    margin-left: 20px;
    margin-top: 9px;
    margin-right: 5px;
 }
`